//#region Import
import React, { Component } from 'react';

/* React Router */
import { Link, Switch, Route, Redirect } from 'react-router-dom'

/* Query String */
import queryString from 'query-string'

/* Object Json */
import { isNone, isEmpty } from 'iotera-base/object'
import { safeDeepGet, safeDeepGetWithType, has } from 'iotera-base/json'

/* Pages */
import SignIn from '../view/pages/signin'
import Register from '../view/pages/register'
import ForgetPass from '../view/pages/forget'
import Page404 from '../view/pages/404'
import PageInvoice from '../view/pages/invoice'

/* Test */
import Test from '../view/pages/test'

/* Login */
import TenantLogin from '../view/login/tenant-login'
import AppLogin from '../view/login'

/* Main */
import TenantMain from '../view/main/main'

/* App */
import TenantApps from '../view/app/tenant-apps'
import App from '../view/app/app'

/* Apps */
import ApplicationList from '../view/application-list'
import ApplicationAdd from '../view/application-add'

/* Apps */
// import GateList from '../view/lora-gate-list'
// import GateAdd from '../view/lora-gate-add'
// import GateEdit from '../view/lora-gate-edit'

/* Credentials */
import Credentials from '../view/credentials-list'
import CredentialsCreateUpdate from '../view/credentials-create-update'

/* Dashboard */
import Dashboard from '../template/dashboard'
import DashboardAddV2 from '../template/dashboard-conf'
import DashboardAddComp from '../view/dashboard-add-component'
import DashboardManualAddComp from '../view/dashboard-add-component-manual'
import DashboardEditComp from '../view/dashboard-edit-component'
import DashboardManualEditComp from '../view/dashboard-edit-component-manual'
import DashboardList from '../view/dashboard-list'
import DashboardAdd from '../view/dashboard-add'
import DashboardEdit from '../view/dashboard-edit'

/* Device */
// import Device from '../view/device'
import DeviceInfo from '../view/device/info'
import DeviceDataAll from '../view/device/data/all'
import DeviceDataDetail from '../view/device/data/detail'
import DeviceState from '../view/device/state/detail'
import DeviceList from '../view/device-list'

import DeviceAddCat from '../view/device-add/category'
import DeviceAddInfo from '../view/device-add/device'
import DeviceAddTag from '../view/device-add/tag'
import DeviceAddTagCat from '../view/device-add/tag-cat'
import DeviceAddSensors from '../view/device-add/config'
import DeviceAddActivation from '../view/device-add/activation'
// import DeviceAddActivationLora from '../view/device-add/activation/lora-activation'
import DeviceAddActivationZlan from '../view/device-add/activation/zlan-activation'
import DeviceAddActivationUsrIot from '../view/device-add/activation/usr-iot-activation'
import DeviceAddActivationBivocom from '../view/device-add/activation/bivocom-activation'
import DeviceAddActivationFriendcom from '../view/device-add/activation/friendcom-activation'
import DeviceAddActivationIotera from '../view/device-add/activation/iotera-device-activation'
import DeviceAddActivationEmma from '../view/device-add/activation/emma-activation'
import DeviceAddActivationImouCamera from '../view/device-add/activation/imou-camera-activation'

import DeviceEditInfo from '../view/device-edit/device'
import DeviceEditInfoMqtt from '../view/device-edit/device/mqtt'
import DeviceEditInfoTasmota from '../view/device-edit/device/tasmota'
// import DeviceEditInfoLora from '../view/device-edit/device/lora'
import DeviceEditInfoUI from '../view/device-edit/device/usr-iot'
import DeviceEditInfoZlan from '../view/device-edit/device/zlan'
import DeviceEditInfoBivocom from '../view/device-edit/device/bivocom'
import DeviceEditInfoFriendcom from '../view/device-edit/device/friendcom'
import DeviceEditInfoIotera from '../view/device-edit/device/iotera'
import DeviceEditInfoEmma from '../view/device-edit/device/emma'
import DeviceEditInfoImouCamera from '../view/device-edit/device/imou_camera'
import DeviceEditSensors from '../view/device-edit/config'
import DeviceEditTagCat from '../view/device-edit/tag-cat'
import DeviceEditTag from '../view/device-edit/tag'

/* User */
import UserList from '../view/user-list'
import UserAdd from '../view/user-add'
import UserEdit from '../view/user-edit'
import UserEditPassword from '../view/user-edit-password'
import TenantRegis from '../view/tenant-reg'

/* Role */
import RoleList from '../view/role-list'
import RoleAddRole from '../view/role-add/role'
import RoleAddAccess from '../view/role-add/access'
import RoleAddSort from '../view/role-add/sort'
import RoleEditRole from '../view/role-edit/role'
import RoleEditAccess from '../view/role-edit/access'
import RoleEditSort from '../view/role-edit/sort'

/* Tags */
import TagList from '../view/tag-list'
import TagAdd from '../view/tag-add'

/* Task */
import TaskList from '../view/task-list'
import TaskAction from '../view/task-action'
// import TagEdit from '../view/tag-edit'

/* Rule */
import RuleList from '../view/rule-list'
import RuleCreate from '../view/rule-create'
import RuleUpdate from '../view/rule-update'
import RuleCreateEditorInfo from '../view/rule-create/rule-create-editor-info'
import RuleCreateEditorTrigger from '../view/rule-create/rule-create-editor-trigger'
import RuleCreateEditorAction from '../view/rule-create/rule-create-editor-action'
import RuleCreateEditorActionTask from '../view/rule-create/rule-create-editor-action-task'
import RuleUpdateEditorInfo from '../view/rule-update/rule-update-editor-info'
import RuleUpdateEditorTrigger from '../view/rule-update/rule-update-editor-trigger'
import RuleUpdateEditorAction from '../view/rule-update/rule-update-editor-action'
import RuleUpdateEditorActionTask from '../view/rule-update/rule-update-editor-action-task'

/* About */
import About from '../view/about'

/* Billing */
import BillingExpired from '../view/billing-expired';

/* Api */
import Api from '../view/api'
import { DEVICE_CAT_MQTT, DEVICE_CAT_TASMOTA, DEVICE_CAT_LORA, DEVICE_CAT_ZLAN, DEVICE_CAT_UI, DEVICE_CAT_BIVOCOM, DEVICE_CAT_FRIENDCOM, DEVICE_CAT_IOTERA, DEVICE_CAT_IMOU_CAMERA, DEVICE_CAT_EMMA } from '../lib/components/Preference';

//#endregion

/* Domain */
export const S = '/';
export const DOMAIN = 'domain';

export const DOMAIN_PARAM = ':domain';
export const S_DOMAIN_PARAM = S + DOMAIN_PARAM;
export const ID_PARAM = ':id';
export const S_ID_PARAM = S + ID_PARAM;

export const TENANT = 'admin';
export const APP = 'app';
export const APPS = 'apps';
export const GATES = 'lora_gates';
export const APPLICATION = 'application';
export const APPLICATIONS = 'applications';
export const LOGIN = 'login';
export const REGIS = 'registration';
export const EXPIRE = 'expire'

export const S_TENANT = S + TENANT;
export const S_APP = S + APP;
export const S_APPS = S + APPS;
export const S_GATES = S + GATES;
export const S_APPLICATION = S + APPLICATION;
export const S_APPLICATIONS = S + APPLICATIONS;
export const S_LOGIN = S + LOGIN;
export const S_REGIS = S + REGIS;
export const S_EXPIRE = S + EXPIRE

export const domain = (props) => {
    if (has(props, 'domain')) {
        return safeDeepGet(props, ['domain']);
    } else {
        return safeDeepGet(props, ['match', 'params', DOMAIN]);
    }
}

export const isTenant = (props) => {
    if (has(props, 'isTenant')) {
        return safeDeepGet(props, ['isTenant']);
    } else {
        const path = safeDeepGet(props, ['match', 'path']);
        if (path !== null) {
            return path.includes(S_TENANT + S);
        } else {
            return false;
        }
    }
}

export const domainIsTenant = (props) => {
    return {
        domain: domain(props),
        isTenant: isTenant(props)
    }
}

export const isAppsPage = (props) => {
    const path = safeDeepGetWithType(props, ['match', 'path'], 'path');
    return path === (S_TENANT + S_APPS);
}

export const isLoraGatesPage = (props) => {
    const path = safeDeepGetWithType(props, ['match', 'path'], 'path');
    return path === (S_TENANT + S_GATES);
}

export const RedirectToApp = (props) => {

    const _domain = domain(props);
    const _isTenant = isTenant(props);

    if (_isTenant) {
        const search = safeDeepGet(props, ['location', 'search'])
        const parsed = queryString.parse(search)
        const redirectURL = parsed['redirectURL']
        if (isNone(redirectURL)) {
            return (
                <Redirect to={S_TENANT + S_APPS} />
            )
        }
        else {
            return (
                <Redirect to={redirectURL} />
            )
        }
    } else {
        const _prefixS = pathPrefixS(_domain, _isTenant);
        return (
            <Redirect to={_prefixS} />
        )
    }
}

export const RedirectToLogin = (props) => {

    const _domain = domain(props);
    const _isTenant = isTenant(props);

    if (_isTenant) {
        return (
            <Redirect to={S_TENANT + S_LOGIN} />
        )
    } else {
        const _prefixS = pathPrefixS(_domain, _isTenant);
        return (
            <Redirect to={_prefixS + LOGIN} />
        )
    }
}


export const RedirectToHomepage = () => {

    return (
        <Redirect to={S_TENANT + S + LOGIN} />
    )
}

export const pathPrefixC = (domain, isTenant) => {
    let prefix = '';
    if (!isNone(domain)) {
        if (isTenant) {
            prefix = S_TENANT + S + domain;
        } else {
            prefix = S + domain;
        }
    }
    return prefix;
}

export const pathPrefixS = (domain, isTenant) => {
    return pathPrefixC(domain, isTenant) + S;
}

export const TenantLink = (props) => {

    const to = safeDeepGetWithType(props, ['to'], '');
    return (
        <Link to={S_TENANT + S + to} >
            {props.children}
        </Link>
    )
}

export const TenantAppsLink = (props) => {

    const to = safeDeepGetWithType(props, ['to'], '');
    return (
        <Link to={S_TENANT + S_APPS + S + to} >
            {props.children}
        </Link>
    )
}

export const AppLink = (props) => {

    const _domain = domain(props);
    const _isTenant = isTenant(props);
    const _prefixS = pathPrefixS(_domain, _isTenant);
    const to = safeDeepGetWithType(props, ['to'], S);

    return (
        <Link to={_prefixS + to} >
            {props.children}
        </Link>
    )
}

export const MainRoutes = () => (
    <Switch>
        <Route exact path='/pages/signin' component={SignIn} />
        <Route exact path='/pages/register' component={Register} />
        <Route exact path='/pages/forget' component={ForgetPass} />
        <Route exact path='/pages/404' component={Page404} />
        <Route exact path='/pages/invoice' component={PageInvoice} />
        <Route exact path='/pages/test' component={Test} />

        <Redirect exact from='/pages' to={S_TENANT + S_LOGIN} />

        {/* Homepage must be tenant login page */}
        <Redirect exact from={S} to={S_TENANT + S_LOGIN} />

        {/* Billing Expired */}
        <Route exact path={S_EXPIRE} component={BillingExpired} />

        {/* Tenant Login */}
        <Route exact path={S_TENANT + S_LOGIN} component={TenantLogin} />
        <Route exact path={S_TENANT + S_REGIS} component={TenantRegis} />

        {/* Tenant Main */}
        <Route exact path={S} component={TenantMain} />
        <Redirect from={S_APP} to={S} />
        <Redirect from={S_APPS} to={S} />
        <Redirect from={S_GATES} to={S} />
        <Redirect from={S_APPLICATION} to={S} />
        <Redirect from={S_APPLICATIONS} to={S} />

        {/* Tenant Apps */}
        <Route path={S_TENANT + S_GATES} component={TenantApps} />
        <Route path={S_TENANT + S_APPS} component={TenantApps} />
        <Redirect exact from={S_TENANT} to={S_TENANT + S_APPS} />
        <Redirect from={S_TENANT + S_APP} to={S_TENANT + S_APPS} />
        <Redirect from={S_TENANT + S_APPLICATION} to={S_TENANT + S_APPS} />
        <Redirect from={S_TENANT + S_APPLICATIONS} to={S_TENANT + S_APPS} />

        {/* App Login*/}
        <Route exact path={S_DOMAIN_PARAM + S_LOGIN} component={AppLogin} />

        {/* App Main */}
        <Route path={S_TENANT + S_DOMAIN_PARAM} component={App} />
        <Route path={S_DOMAIN_PARAM} component={App} />

    </Switch>
);

export class TenantAppsRoutes extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={S_TENANT + S_APPS + S + 'list'} component={ApplicationList} />
                <Route exact path={S_TENANT + S_APPS + S + 'add'} component={ApplicationAdd} />
                {/* <Route exact path={S_TENANT + S_GATES + S + 'list'} component={GateList} />
                <Route exact path={S_TENANT + S_GATES + S + 'add'} component={GateAdd} />
                <Route exact path={S_TENANT + S_GATES + S + 'edit' + S + ':id'} component={GateEdit} /> */}
                <Redirect from={S_TENANT + S_APPS} to={S_TENANT + S_APPS + S + 'list'} />
            </Switch>
        )
    }
}

const pushExactRoute = (routers, Component, path, props, key) => {
    routers.push(<Route key={key} exact path={path} render={(routerprops) => (
        <Component {...props} {...routerprops} />
    )} />);
}

const pushExactRedirect = (routers, from, to, key) => {
    routers.push(<Redirect key={key} exact from={from} to={to} />);
}

const pushRedirect = (routers, from, to, key) => {
    routers.push(<Redirect key={key} from={from} to={to} />);
}

export const AppRoutes = (props) => {

    const _domain = domain(props);
    const _isTenant = isTenant(props);
    const _prefixS = pathPrefixS(_domain, _isTenant);

    const navMap = safeDeepGetWithType(props, ['navMap'], {});
    const routers = [];
    let topRoute = null;
    let key = 1;
    if (_isTenant) {

        // For Tenant  
        for (let id in navMap) {

            const nav = navMap[id];
            const path = safeDeepGetWithType(nav, ['path'], '');
            if (path.includes('_')) {
                continue;
            }

            pushExactRoute(routers, Dashboard, _prefixS + path, { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
            pushExactRoute(routers, DashboardAddV2, _prefixS + '_dashboard_conf_' + S + path, { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
            pushExactRoute(routers, DashboardAddComp, _prefixS + '_dashboard_conf_' + S + path + S + 'add', { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
            pushExactRoute(routers, DashboardManualAddComp, _prefixS + '_dashboard_conf_' + S + path + S + 'manual_add', { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
            pushExactRoute(routers, DashboardEditComp, _prefixS + '_dashboard_conf_' + S + path + S + 'edit' + S + ':id', { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
            pushExactRoute(routers, DashboardManualEditComp, _prefixS + '_dashboard_conf_' + S + path + S + 'manual_edit' + S + ':id', { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
            // pushExactRoute(routers, DashboardAddV2, _prefixS + '_dashboard_conf_' + S + ':id', { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
        }

        if (isNone(topRoute)) {
            // topRoute = _prefixS + '_dashboard_list_';
            topRoute = _prefixS + '_device_list_';
        }
        pushExactRoute(routers, DashboardList, _prefixS + '_dashboard_list_', { domain: _domain, isTenant: _isTenant }, key++);
        // pushExactRedirect(routers, _prefixS, _prefixS + '_dashboard_list_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DashboardAdd, _prefixS + '_dashboard_add_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DashboardEdit, _prefixS + '_dashboard_edit_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        // pushExactRoute(routers, Device, _prefixS + '_device_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceInfo, _prefixS + '_device_info_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceDataAll, _prefixS + '_device_data_all_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceDataDetail, _prefixS + '_device_data_detail_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceState, _prefixS + '_device_state_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceList, _prefixS + '_device_list_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRedirect(routers, _prefixS, _prefixS + '_device_list_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddCat, _prefixS + '_device_add_' + S + 'category', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddInfo, _prefixS + '_device_add_' + S + 'info', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddTagCat, _prefixS + '_device_add_' + S + 'tag_cat', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddTag, _prefixS + '_device_add_' + S + 'tag', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddSensors, _prefixS + '_device_add_' + S + 'sensors', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddActivation, _prefixS + '_device_add_' + S + 'activation', { domain: _domain, isTenant: _isTenant }, key++);
        // pushExactRoute(routers, DeviceAddActivationLora, _prefixS + '_device_add_' + S + 'activation' + S + 'lora', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddActivationZlan, _prefixS + '_device_add_' + S + 'activation' + S + 'zlan', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddActivationUsrIot, _prefixS + '_device_add_' + S + 'activation' + S + 'usr-iot', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddActivationBivocom, _prefixS + '_device_add_' + S + 'activation' + S + 'bivocom', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddActivationFriendcom, _prefixS + '_device_add_' + S + 'activation' + S + 'friendcom', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddActivationIotera, _prefixS + '_device_add_' + S + 'activation' + S + 'iotera', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddActivationEmma, _prefixS + '_device_add_' + S + 'activation' + S + 'emma', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceAddActivationImouCamera, _prefixS + '_device_add_' + S + 'activation' + S + 'imou_camera', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRedirect(routers, _prefixS + '_device_add_', _prefixS + '_device_add_' + S + 'info', key++);
        pushExactRoute(routers, DeviceEditInfo, _prefixS + '_device_edit_' + S + 'info' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditInfoMqtt, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_MQTT + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditInfoTasmota, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_TASMOTA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        // pushExactRoute(routers, DeviceEditInfoLora, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_LORA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditInfoUI, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_UI + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditInfoZlan, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_ZLAN + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditInfoBivocom, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_BIVOCOM + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditInfoFriendcom, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_FRIENDCOM + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditInfoIotera, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_IOTERA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditInfoEmma, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_EMMA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditInfoImouCamera, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_IMOU_CAMERA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditTagCat, _prefixS + '_device_edit_' + S + 'tag_cat' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditTag, _prefixS + '_device_edit_' + S + 'tag' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, DeviceEditSensors, _prefixS + '_device_edit_' + S + 'sensors' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRedirect(routers, _prefixS + '_device_edit_' + S + ':id', _prefixS + '_device_edit_' + S + 'info' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, UserList, _prefixS + '_user_list_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, UserAdd, _prefixS + '_user_add_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, UserEdit, _prefixS + '_user_edit_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, UserEditPassword, _prefixS + '@user/password' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RoleList, _prefixS + '_role_list_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RoleAddRole, _prefixS + '_role_add_info_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RoleAddAccess, _prefixS + '_role_add_access_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RoleAddSort, _prefixS + '_role_add_sort_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RoleEditRole, _prefixS + '_role_edit_role_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RoleEditAccess, _prefixS + '_role_edit_access_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RoleEditSort, _prefixS + '_role_edit_sort_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, TagList, _prefixS + '_tag_list_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, TaskList, _prefixS + '_task_list_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, TaskAction, _prefixS + '_task_action_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleList, _prefixS + '_rule_list_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleCreate, _prefixS + '_rule_add_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleCreateEditorInfo, _prefixS + '@rule/create/editor/info', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleCreateEditorTrigger, _prefixS + '@rule/create/editor/trigger', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleCreateEditorAction, _prefixS + '@rule/create/editor/action', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleCreateEditorActionTask, _prefixS + '@rule/create/editor/action/task', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleCreateEditorActionTask, _prefixS + '@rule/create/editor/action/task' + S + ':taskId', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleUpdate, _prefixS + '_rule_edit_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleUpdateEditorInfo, _prefixS + '@rule/update/editor/info' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleUpdateEditorTrigger, _prefixS + '@rule/update/editor/trigger' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleUpdateEditorAction, _prefixS + '@rule/update/editor/action' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, RuleUpdateEditorActionTask, _prefixS + '@rule/update/editor/action/task' + S + ':id' + S + ':taskId', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, TagAdd, _prefixS + '_tag_add_', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, Credentials, _prefixS + '@credentials', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, CredentialsCreateUpdate, _prefixS + '@credentials/create', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, CredentialsCreateUpdate, _prefixS + '@credentials/update' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
        pushExactRoute(routers, About, _prefixS + '@about', { domain: _domain, isTenant: _isTenant }, key++);

    } else {
        // For App
        let deviceListFlag = false;
        let userManageFlag = false;
        let taskListFlag = false;

        for (let id in navMap) {

            const nav = navMap[id];
            const path = safeDeepGetWithType(nav, ['path'], '');

            if (path.includes('_')) {
                continue;
            }

            if (isNone(topRoute)) {
                topRoute = _prefixS + path;
            }

            pushExactRoute(routers, Dashboard, _prefixS + path, { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
            // pushExactRoute(routers, DashboardAddV2, _prefixS + '_dashboard_conf_' + S + path, { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
            // pushExactRoute(routers, DashboardAddComp, _prefixS + '_dashboard_conf_' + S + path + S + 'add', { id: id, key: id, domain: _domain, isTenant: _isTenant }, key++);
        }

        for (let id in navMap) {

            const nav = navMap[id];
            const path = safeDeepGetWithType(nav, ['path'], '');

            if (path === '_dashboard_manage_') {
                if (isNone(topRoute)) {
                    topRoute = _prefixS + '_dashboard_list_';
                }
                pushExactRoute(routers, DashboardList, _prefixS + '_dashboard_list_', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DashboardAddV2, _prefixS + '_dashboard_conf_' + S + ':id', { id: id, domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DashboardAdd, _prefixS + '_dashboard_add_', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DashboardEdit, _prefixS + '_dashboard_edit_' + S + ':id', { domain: _domain, isTenant: _isTenant, id: id }, key++);

            } else if (path === '_device_manage_') {

                if (!deviceListFlag) {
                    // pushExactRoute(routers, Device, _prefixS + '_device_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, DeviceInfo, _prefixS + '_device_info_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, DeviceDataAll, _prefixS + '_device_data_all_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, DeviceDataDetail, _prefixS + '_device_data_detail_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, DeviceState, _prefixS + '_device_state_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    if (isNone(topRoute)) {
                        topRoute = _prefixS + '_device_list_';
                    }
                    pushExactRoute(routers, DeviceList, _prefixS + '_device_list_', { domain: _domain, isTenant: _isTenant }, key++);
                    deviceListFlag = true;
                }

                pushExactRoute(routers, DeviceAddCat, _prefixS + '_device_add_' + S + 'category', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddInfo, _prefixS + '_device_add_' + S + 'info', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddTag, _prefixS + '_device_add_' + S + 'tag', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddTagCat, _prefixS + '_device_add_' + S + 'tag_cat', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddSensors, _prefixS + '_device_add_' + S + 'sensors', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddActivation, _prefixS + '_device_add_' + S + 'activation', { domain: _domain, isTenant: _isTenant }, key++);
                // pushExactRoute(routers, DeviceAddActivationLora, _prefixS + '_device_add_' + S + 'activation' + S + 'lora', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddActivationZlan, _prefixS + '_device_add_' + S + 'activation' + S + 'zlan', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddActivationUsrIot, _prefixS + '_device_add_' + S + 'activation' + S + 'usr-iot', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddActivationBivocom, _prefixS + '_device_add_' + S + 'activation' + S + 'bivocom', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddActivationFriendcom, _prefixS + '_device_add_' + S + 'activation' + S + 'friendcom', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddActivationIotera, _prefixS + '_device_add_' + S + 'activation' + S + 'iotera', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddActivationEmma, _prefixS + '_device_add_' + S + 'activation' + S + 'emma', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceAddActivationImouCamera, _prefixS + '_device_add_' + S + 'activation' + S + 'imou_camera', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRedirect(routers, _prefixS + '_device_add_', _prefixS + '_device_add_' + S + 'info', key++);
                pushExactRoute(routers, DeviceEditInfo, _prefixS + '_device_edit_' + S + 'info' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditInfoMqtt, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_MQTT + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditInfoTasmota, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_TASMOTA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                // pushExactRoute(routers, DeviceEditInfoLora, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_LORA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditInfoUI, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_UI + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditInfoZlan, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_ZLAN + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditInfoBivocom, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_BIVOCOM + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditInfoFriendcom, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_FRIENDCOM + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditInfoIotera, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_IOTERA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditInfoEmma, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_EMMA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditInfoImouCamera, _prefixS + '_device_edit_' + S + 'info' + S + DEVICE_CAT_IMOU_CAMERA + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditTagCat, _prefixS + '_device_edit_' + S + 'tag_cat' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditTag, _prefixS + '_device_edit_' + S + 'tag' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, DeviceEditSensors, _prefixS + '_device_edit_' + S + 'sensors' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRedirect(routers, _prefixS + '_device_edit_', _prefixS + '_device_edit_' + S + 'info', key++);

            } else if (path === '_device_list_') {

                if (!deviceListFlag) {
                    // pushExactRoute(routers, Device, _prefixS + '_device_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, DeviceInfo, _prefixS + '_device_info_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, DeviceDataAll, _prefixS + '_device_data_all_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, DeviceDataDetail, _prefixS + '_device_data_detail_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, DeviceState, _prefixS + '_device_state_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    if (isNone(topRoute)) {
                        topRoute = _prefixS + '_device_list_';
                    }
                    pushExactRoute(routers, DeviceList, _prefixS + '_device_list_', { domain: _domain, isTenant: _isTenant }, key++);
                    deviceListFlag = true;
                }

            } else if (path === '_role_manage_') {

                if (!userManageFlag) {
                    pushExactRoute(routers, UserList, _prefixS + '_user_list_', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, UserAdd, _prefixS + '_user_add_', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, UserEdit, _prefixS + '_user_edit_' + S + ':id', { domain: _domain, isTenant: _isTenant, id: id }, key++);
                    userManageFlag = true;
                }

                pushExactRoute(routers, RoleList, _prefixS + '_role_list_', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, RoleAddRole, _prefixS + '_role_add_info_', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, RoleAddAccess, _prefixS + '_role_add_access_', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, RoleAddSort, _prefixS + '_role_add_sort_', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, RoleEditRole, _prefixS + '_role_edit_role_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, RoleEditAccess, _prefixS + '_role_edit_access_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                pushExactRoute(routers, RoleEditSort, _prefixS + '_role_edit_sort_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);

            } else if (path === '_user_manage_') {

                if (!userManageFlag) {
                    pushExactRoute(routers, UserList, _prefixS + '_user_list_', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, UserAdd, _prefixS + '_user_add_', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, UserEdit, _prefixS + '_user_edit_' + S + ':id', { domain: _domain, isTenant: _isTenant, id: id }, key++);
                    userManageFlag = true;
                }

            } else if (path === '_task_manage_') {

                if (!taskListFlag) {

                    taskListFlag = true;
                }


            } else if (path === '_task_list_') {

                if (!taskListFlag) {
                    pushExactRoute(routers, TaskList, _prefixS + '_task_list_', { domain: _domain, isTenant: _isTenant }, key++);
                    pushExactRoute(routers, TaskAction, _prefixS + '_task_action_' + S + ':id', { domain: _domain, isTenant: _isTenant }, key++);
                    taskListFlag = true;
                }

            }

            // TODO
            // pushExactRoute(routers, Api, _prefixS + '_api_', { domain: _domain, isTenant: _isTenant }, key++);
        }
    }

    if (!_isTenant) {
        // pushExactRoute(routers, Api, _prefixS + '_api_', { domain: _domain, isTenant: _isTenant }, key++);
    }


    if (!isEmpty(navMap) && !isNone(topRoute)) {
        // To debug Routes, comment this
        pushRedirect(routers, _prefixS, topRoute, key++);
    }

    return (
        <Switch>
            {routers}
        </Switch>
    );
}
